import React from 'react';
import { FormComponent, FormComponentProps } from '../index';
import FormField from '../../common/form-field';
import { useTranslation } from 'react-i18next';

export default function HtmlBlock(label: string, children: any): FormComponent {
  return ({ ...rest }) => (
    <HtmlBlockComponent label={label} {...rest}>
      {children}
    </HtmlBlockComponent>
  );
}

export function HtmlBlockComponent({
  label,
  children,
}: FormComponentProps & {
  label: string;
  children: any;
}) {
  const { t } = useTranslation();

  return (
    <FormField label={t(label) || ' '} labelFor={null}>
      {children}
    </FormField>
  );
}
